/* eslint-disable  @typescript-eslint/no-unused-vars */
/* eslint-disable  @typescript-eslint/no-useless-constructor */
/* eslint-disable  @typescript-eslint/no-redundant-type-constituents */
/* eslint-disable @typescript-eslint/no-extraneous-class */
/* eslint-disable @typescript-eslint/no-empty-object-type */
import { z } from 'zod';
import { validate } from '../../error/validate';
import { enumSchema, domainWsIntervalTypeSchema, type DomainWsIntervalType, localDatetimeSchema, type DomainWsVariantObject, type DomainWsVariantAvailability, type DomainJsonObject, type DomainWspdclasttrans, type DomainWscommitid, } from '../../schema';
import { type WebResponseResult, ValidationError } from '@pdcfrontendui/staffplan';
import { WebRequest } from './WebRequest';
import {
  WebTypeViewField,
  WebField,
  WebRecord,
  WebList,
  WebElement,
  LogonSettings,
  WebSortConfig,
  WebFieldConfig,
  WebListConfig,
  WebRecordType,
  WsRefPerson,
  WsRefOrgunit,
  WsRefOrgunitByInfo,
  WsRefShiftCounter,
  WsRefShifttype,
  WsRefTaskDef,
  WsRefTask,
  WsRefAccount,
  WsRefProject,
  WsRefDimensionItem,
  PersonInfo,
  PersonGroupMember,
  globalSettingsSchema,
  webElementSchema,
  webFieldConfigSchema,
  webFieldSchema,
  webListConfigSchema,
  webListSchema,
  webRecordSchema,
  webRecordTypeSchema,
  webSortConfigSchema,
  webTypeViewFieldSchema,
  wsRefAccountByNameSchema,
  wsRefAccountSchema,
  wsRefDimensionItemByNameSchema,
  wsRefDimensionItemSchema,
  wsRefOrgunitByInfoSchema,
  wsRefOrgunitSchema,
  wsRefPersonByAuxSchema,
  wsRefPersonByNameSchema,
  wsRefPersonBySalaryIdSchema,
  wsRefPersonSchema,
  wsRefProjectByNameSchema,
  wsRefProjectSchema,
  wsRefShiftCounterSchema,
  wsRefShiftDefByExternalIdSchema,
  wsRefShiftDefByIdSchema,
  wsRefShiftDefByNameSchema,
  wsRefShiftDefSchema,
  wsRefShiftTypeByExternalIdSchema,
  wsRefShiftTypeByNameSchema,
  wsRefShifttypeSchema,
  wsRefTaskByExternalIdSchema,
  wsRefTaskByNameSchema,
  wsRefTaskDefByExternalIdSchema,
  wsRefTaskDefByNameSchema,
  wsRefTaskDefSchema,
  wsRefTaskSchema,
  personInfoSchema,
  personGroupMemberSchema,
  globalSettingsJsonSchema,
  webElementJsonSchema,
  webFieldConfigJsonSchema,
  webFieldJsonSchema,
  webListConfigJsonSchema,
  webListJsonSchema,
  webRecordJsonSchema,
  webRecordTypeJsonSchema,
  webSortConfigJsonSchema,
  webTypeViewFieldJsonSchema,
  wsRefAccountByNameJsonSchema,
  wsRefAccountJsonSchema,
  wsRefDimensionItemByNameJsonSchema,
  wsRefDimensionItemJsonSchema,
  wsRefOrgunitByInfoJsonSchema,
  wsRefOrgunitJsonSchema,
  wsRefPersonByAuxJsonSchema,
  wsRefPersonByNameJsonSchema,
  wsRefPersonBySalaryIdJsonSchema,
  wsRefPersonJsonSchema,
  wsRefProjectByNameJsonSchema,
  wsRefProjectJsonSchema,
  wsRefShiftCounterJsonSchema,
  wsRefShiftDefByExternalIdJsonSchema,
  wsRefShiftDefByIdJsonSchema,
  wsRefShiftDefByNameJsonSchema,
  wsRefShiftDefJsonSchema,
  wsRefShiftTypeByExternalIdJsonSchema,
  wsRefShiftTypeByNameJsonSchema,
  wsRefShifttypeJsonSchema,
  wsRefTaskByExternalIdJsonSchema,
  wsRefTaskByNameJsonSchema,
  wsRefTaskDefByExternalIdJsonSchema,
  wsRefTaskDefByNameJsonSchema,
  wsRefTaskDefJsonSchema,
  wsRefTaskJsonSchema,
  personInfoJsonSchema,
  personGroupMemberJsonSchema,
} from './Common_api';
import { PlanEnum, AttendanceClockInOutEnum, TimeAttendanceDeviationEnum, WsAttendanceQueryTypeEnum, TimeAttendanceRefTypeEnum, WsTimeRegEventTypeEnum, PushProviderTypeEnum, ApplicationEnum, PlanSchema, AttendanceClockInOutSchema, TimeAttendanceDeviationSchema, WsAttendanceQueryTypeSchema, TimeAttendanceRefTypeSchema, WsTimeRegEventTypeSchema, PushProviderTypeSchema, ApplicationSchema, PlanJsonSchema, AttendanceClockInOutJsonSchema, TimeAttendanceDeviationJsonSchema, WsAttendanceQueryTypeJsonSchema, TimeAttendanceRefTypeJsonSchema, WsTimeRegEventTypeJsonSchema, PushProviderTypeJsonSchema, ApplicationJsonSchema } from './enumLib_api';
/**
	RegisterDevice. Old versions of this api did not take applicationId
	Responsible: PM, Updated: 20190123
*/
export class RegisterDevice extends WebRequest<boolean> {
	public readonly webService = "pushNotification";
	public readonly method = "RegisterDevice";
	public readonly noUserValidation = false;
	public readonly noAuditAction = true;

	constructor(
		public DeviceToken: string,
		public ServiceType: PushProviderTypeEnum,
	) {
		super();
	}

	public static readonly create = (x: {DeviceToken: string, ServiceType: PushProviderTypeEnum}): RegisterDevice => {
        return new RegisterDevice(x.DeviceToken, x.ServiceType);
          }
	public static readonly returnSchema = z.boolean();
	public resultFromJSON(json: WebResponseResult<boolean>): boolean {
		return validate(RegisterDevice.returnSchema, json) as unknown as boolean;
	}
}

/**
	Returns whether the staffuserid (specified in the JWT) wants push notifications
	Responsible: PM, Updated: 20190131
*/
export class GetAllowNotifications extends WebRequest<boolean> {
	public readonly webService = "pushNotification";
	public readonly method = "GetAllowNotifications";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
	) {
		super();
	}

	public static readonly create = (x: {}): GetAllowNotifications => {
        return new GetAllowNotifications();
          }
	public static readonly returnSchema = z.boolean();
	public resultFromJSON(json: WebResponseResult<boolean>): boolean {
		return validate(GetAllowNotifications.returnSchema, json) as unknown as boolean;
	}
}

/**
	Set whether the staffuserid (specified in the JWT) wants push notifications
	Responsible: PM, Updated: 20190131
*/
export class SetAllowNotifications extends WebRequest<boolean> {
	public readonly webService = "pushNotification";
	public readonly method = "SetAllowNotifications";
	public readonly noUserValidation = false;
	public readonly noAuditAction = false;

	constructor(
		public AllowNotification: boolean,
	) {
		super();
	}

	public static readonly create = (x: {AllowNotification: boolean}): SetAllowNotifications => {
        return new SetAllowNotifications(x.AllowNotification);
          }
	public static readonly returnSchema = z.boolean();
	public resultFromJSON(json: WebResponseResult<boolean>): boolean {
		return validate(SetAllowNotifications.returnSchema, json) as unknown as boolean;
	}
}

export const RegisterDeviceAI = { key: 'pushNotification_RegisterDevice' as const,
          webService: 'pushNotification' as const,
           method: 'RegisterDevice' as const,
           description: "RegisterDevice. Old versions of this api did not take applicationId",
           inputJsonSchema: z.object({ DeviceToken: z.string(), ServiceType: PushProviderTypeJsonSchema}),
           inputSchema: z.object({ DeviceToken: z.string(), ServiceType: PushProviderTypeSchema}),
          outputJsonSchema: z.boolean(),
          outputSchema: z.boolean(),
          requestClass: RegisterDevice
          }
export const GetAllowNotificationsAI = { key: 'pushNotification_GetAllowNotifications' as const,
          webService: 'pushNotification' as const,
           method: 'GetAllowNotifications' as const,
           description: "Returns whether the staffuserid (specified in the JWT) wants push notifications",
           inputJsonSchema: z.object({ }),
           inputSchema: z.object({ }),
          outputJsonSchema: z.boolean(),
          outputSchema: z.boolean(),
          requestClass: GetAllowNotifications
          }
export const SetAllowNotificationsAI = { key: 'pushNotification_SetAllowNotifications' as const,
          webService: 'pushNotification' as const,
           method: 'SetAllowNotifications' as const,
           description: "Set whether the staffuserid (specified in the JWT) wants push notifications",
           inputJsonSchema: z.object({ AllowNotification: z.boolean()}),
           inputSchema: z.object({ AllowNotification: z.boolean()}),
          outputJsonSchema: z.boolean(),
          outputSchema: z.boolean(),
          requestClass: SetAllowNotifications
          }
export const endpoints = [RegisterDeviceAI, GetAllowNotificationsAI, SetAllowNotificationsAI] as const;
export type Endpoint = (typeof endpoints)[number];
